import {
  useGetTagListNameIdQuery,
  type PostFilter,
} from "@package/ui-gql/index-data-access";
import { type WritableDraft } from "immer";
import { uniq } from "lodash";
import { useMemo, useState } from "react";
import { useItemGridFilterContext } from "../ItemGridFilter/context-item-grid-filter";
import {
  ItemGridFilterDataList,
  type FilterValueEntry,
} from "../ItemGridFilter/ItemGridFilterDataList";

type SupportedFilter = PostFilter | null | undefined;

export function ItemGridFilterTags() {
  const [query, setQuery] = useState<string>("");

  const { filter, updateFilterState } = useItemGridFilterContext();
  const { data, loading, error } = useGetTagListNameIdQuery({
    variables: {
      page: 0,
      perPage: 1000,
      sortField: "title",
      sortOrder: "ASC",
      filter: (query && { q: query }) || undefined,
    },
  });

  const filterWithTags: SupportedFilter = filter;
  const items = useMemo<FilterValueEntry[]>(() => {
    const values: FilterValueEntry[] =
      data?.items
        ?.slice()
        ?.filter((item) => !!item?.id)
        ?.map((item) => {
          const id = item.id ?? "";
          const name = item.title ?? "";
          const checked = filterWithTags?.tags?.includes(id) ?? false;
          return {
            id,
            name,
            checked,
          };
        }) ?? [];

    return values;
  }, [data?.items, filterWithTags?.tags]);

  return (
    <ItemGridFilterDataList
      error={error}
      items={items}
      loading={loading}
      property="tags"
      text="Tags"
      onQueryValueChanged={setQuery}
      onRequestFilterReset={() =>
        updateFilterState((draft: WritableDraft<SupportedFilter>) => {
          if (draft) {
            delete draft.tags;
          }
        })
      }
      onRequestFilterUpdate={(id, include) =>
        updateFilterState((draft: WritableDraft<SupportedFilter>) => {
          if (draft) {
            if (include) {
              draft.tags = uniq([...(draft.tags ?? []), id]);
            } else if (draft.tags?.length) {
              draft.tags = draft.tags.filter((tag) => tag !== id);
            }

            if (!draft.tags?.length) {
              delete draft.tags;
            }
          }
        })
      }
      onSelectAllChanged={(checked) => {
        if (checked) {
          updateFilterState((draft: WritableDraft<SupportedFilter>) => {
            if (draft) {
              draft.tags = items.map((item) => item.id);
            }
          });
        } else {
          updateFilterState((draft: WritableDraft<SupportedFilter>) => {
            if (draft) {
              delete draft.tags;
            }
          });
        }
      }}
    />
  );
}
